(() => {
  if (customElements.get('optik-lookbook')) return;
  customElements.define('optik-lookbook', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const track = this.querySelector('[data-track]');
      const cards = [...track.children];
      const previous = this.querySelector('[data-previous]');
      const next = this.querySelector('[data-next]');
      const status = this.querySelector('[data-status]');
      const move = direction => track.scrollBy({left: direction * (cards[0].getBoundingClientRect().width + 20), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      const update = () => {
        previous.disabled = track.scrollLeft < 4;
        next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 4;
        const bounds = track.getBoundingClientRect();
        const visible = cards.map((card, i) => ({i, rect: card.getBoundingClientRect()})).filter(({rect}) => rect.left >= bounds.left - 4 && rect.right <= bounds.right + 4).map(({i}) => i + 1);
        status.textContent = visible.length > 1 ? `${visible[0]}–${visible.at(-1)} / ${cards.length}` : `${visible[0] || 1} / ${cards.length}`;
      };
      previous.addEventListener('click', () => move(-1));
      next.addEventListener('click', () => move(1));
      track.addEventListener('keydown', event => {
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault(); move(event.key === 'ArrowRight' ? 1 : -1);
        }
      });
      track.addEventListener('scroll', update, {passive:true});
      this.observer = new ResizeObserver(update); this.observer.observe(track);
      update();
    }
    disconnectedCallback() { this.observer?.disconnect(); this.ready = false; }
  });
})();
